module.exports = __webpack_public_path__ + "img/aq.2d1636b0.svg";